import { render, staticRenderFns } from "./HumanResourcesPolicies.vue?vue&type=template&id=09aec0ba&scoped=true&"
import script from "./HumanResourcesPolicies.vue?vue&type=script&lang=js&"
export * from "./HumanResourcesPolicies.vue?vue&type=script&lang=js&"
import style0 from "./HumanResourcesPolicies.vue?vue&type=style&index=0&id=09aec0ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aec0ba",
  null
  
)

export default component.exports